module.exports = __webpack_public_path__ + "static/media/code1.c1a95f73.svg";